


















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
@Component
export default class TableHeaderSearch extends Vue {
  onClick(val) {
    this.$emit("click", val);
  }
}
